import styled from '@emotion/styled';
import { Link } from '@reach/router';
import { Container, Heading, Paragraph } from 'react-magma-dom';
import { COLORS, DOTTED_FOCUS } from '../../constants';

export const StyledParent = styled(Container)`
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  align-items: center;
  height: 200px;
  width: 100%;
`;

export const StyledBlock = styled.div<{ width: number }>`
  display: grid;
  grid-template-columns: minmax(100px, 100%) 1fr;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  border: solid 1px ${COLORS.veryLightPink};
  max-width: ${({ width }) => width}px;

  &:hover {
    border: solid 1px ${COLORS.seaBlue}!important;
  }
`;

export const StyledContent = styled(Heading)`
  width: 100%;
`;

export const StyledContentText = styled(Paragraph)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledContainer = styled(Container)`
  position: relative !important;
  margin: 24px auto !important;
  max-width: 926px !important;
  height: 120px !important;
  display: block !important;
  padding: 0px !important;
`;

export const StyledLink = styled(Link)`
  color: ${COLORS.seaBlue}!important;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  margin: 0px 43.5px 0px 0px;
  text-decoration: none;
  outline: none;

  ${DOTTED_FOCUS}
`;

export const StyledSubTitle = styled.div`
  width: 100%;
  font-size: 24px;
  margin: 24px 0px 0px 24px;
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const SavedAsIWPLabel = styled.div`
  min-width: 203px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 15px;
  border-radius: 5px;
  background-color: ${COLORS.seaBlue};
  font-size: 14px;
  color: ${COLORS.white};
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 120px;
  width: 100%;
`;

export const StyledCurrentlyView = styled.span`
  font-weight: normal;
  font-size: 14px;
  letter-spacing: 0.16px;
  color: ${COLORS.neutral3};
`;

export interface ILinkWrapper {
  justifyContent?: string;
}

export const StyledLinkWrapper = styled.div<ILinkWrapper>`
  display: flex;
  font-size: 12px;
  margin: 0px 0px 20px 24px;
  ${({ justifyContent }) => (justifyContent ? `justify-content: ${justifyContent}` : null)}
`;

export const StyledLeftSideLinks = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledSavedText = styled.div`
  margin: 40px 0px 24px 0px;
  font-size: 28px;
  font-weight: 600;
  color: ${COLORS.blackOlive};
`;

export const StyledTextType = styled.div`
  position: absolute !important;
  text-align: center;
  left: 50%;
  margin-left: -50px;
  bottom: 22px;

  font-weight: normal;
  font-size: 14px;
  letter-spacing: 0.16px;
  color: ${COLORS.neutral3};
`;

export const StyledProfessionalSeparator = styled.div`
  width: 1px;
  height: 20px;
  background-color: ${COLORS.neutral3};
  margin: 0px 15px;
`;

export const StyledItemData = styled.span`
  display: grid;
  font-weight: 400;
  font-size: 14px;
  color: ${COLORS.neutral3};
  line-height: 1.43;
  letter-spacing: 0.16px;
`;

export const StyledTypeData = styled.span`
  font-weight: 700;
  :first-letter {
    text-transform: uppercase;
  }
`;

export const EllipsisWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface IOpacity {
  opacity: number;
}

export const StyledOpacityWrapper = styled.div<IOpacity>`
  opacity: ${({ opacity }) => opacity};
`;

export const StyledShortRelated = styled.a<{
  gradient: string;
  defaultColor: string;
  disabled?: boolean;
}>`
  justify-content: space-between;
  margin: 10px 0px;
  padding: 15px 0px;
  display: flex;
  height: 54px;
  flex-grow: 0;
  border-radius: 4px;
  border: solid 1px #dfdfdf;

  background: ${COLORS.white};
  color: ${({ defaultColor }) => defaultColor};

  .short-related-download {
    background: ${({ defaultColor }) => defaultColor};
    color: ${COLORS.white};
  }

  &:hover,
  &:focus {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    background: ${({ gradient }) => gradient};

    .short-related-title {
      color: ${COLORS.white};
    }

    .short-related-download {
      background: ${COLORS.white};
      color: ${({ defaultColor }) => defaultColor};
    }

    .file-download-loader {
      span {
        border: 2px solid ${COLORS.white};
        border-right-color: transparent;
      }
    }
  }

  ${DOTTED_FOCUS}
`;

export const StyledHeading = styled.div<{ size: number; margin: string }>`
  margin: ${({ margin }) => margin};
  font-size: ${({ size }) => size}px;
  font-weight: 600;
  color: ${COLORS.blackOlive};
`;

export const StyledHeadingNote = styled.span`
  font-weight: 300;
  padding-left: 1rem;
`;

export const StyledTitle = styled.div`
  padding: 0px 0px 0px 27px;
  color: ${COLORS.blackOlive};
`;

export const StyledType = styled.div`
  text-transform: uppercase;
  padding: 0px 20px 0px 0px;
  color: ${COLORS.blackOlive};
`;

export const StyledMainGradientType = styled.div`
  text-transform: uppercase;
  color: ${COLORS.seaBlue};
`;

export const StyledRightSideWrapper = styled.div`
  padding: 0px 10px 18px 0px;
  text-align: center;
`;
